import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { isChunkError, reloadOnce } from './components/ErrorBoundary'

// Recover from stale Vite chunks after deploy (root cause of Clarity
// "Importing a module script failed" sessions).
window.addEventListener('error', (e) => {
  if (isChunkError(e.error) || (e.message && isChunkError(new Error(e.message)))) {
    reloadOnce();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  if (isChunkError(e.reason)) {
    reloadOnce();
  }
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
